import axios from "axios";
import authHeader from "./AuthHeader";

const API_URL = process.env.VUE_APP_MS_CORE;

class CoreService {
  findAll() {
    return axios.get(`${API_URL}/secure/poi`, { headers: authHeader() });
  }

  findCertificate(customer){
    return axios.get(`${API_URL}/secure/certificate/customer/${customer}`,
      {
        headers: authHeader(),
      })
  }

  doCertificateValidation(payload){
    return axios.post(`${API_URL}/secure/certificate/state`, payload, {
      headers: authHeader(),
    });
  }

  findCertificateTovalidate(customer){
    return axios.get(`${API_URL}/secure/certificate/tovalidate/customer/${customer}`,
      {
        headers: authHeader(),
      })
  }

  loadAvailabilityCal(agreement, year, month) {
    return axios.get(
      `${API_URL}/secure/availableCal/${agreement}/${year}/${month}`,
      {
        headers: authHeader(),
      }
    );
  }

  getDocs(payload) {
    return axios.post(`${API_URL}/secure/edl`, payload, {
      headers: authHeader(),
    });
  }

  download(payload) {
    return axios.get(`${API_URL}/secure/edl/download/${payload}`, {
      headers: authHeader(),
      responseType: "blob",
    });
  }

  getPreventiveRate(agreement) {
    return axios.get(`${API_URL}/secure/contractform/${agreement}`, {
      headers: authHeader(),
    });
  }

  getLeasedAssetByPeriod(customer, start, end) {
    return axios.get(`${API_URL}/secure/assignments/period/${customer}/${start}/${end}`, {
      headers: authHeader(),
    });
  }

  findCaptrainItems() {
    return axios.get(`${API_URL}/secure/customers/captrain/items`, {
      headers: authHeader(),
    });
  }

  findAllUsers() {
    return axios.get(`${API_URL}/secure/users/all`, {
      headers: authHeader(),
    });
  }

  findAllRoles() {
    return axios.get(`${API_URL}/roles`, {
      headers: authHeader(),
    });
  }

  signup(payload) {
    return axios.post(`${API_URL}/secure/signup`, payload, {
      headers: authHeader(),
    })
  }
}

export default new CoreService();
